module.exports = __webpack_public_path__ + "static/media/no-templates.f63d2fd1.svg";